<template>
  <div class="col">
    <span class="detail-text-label">{{title}}</span>
    <span :class="labelClass">{{value}}</span>
  </div>
</template>

<script>
import { parseShow } from '../providers/store-parser'

export default {
  name: 'InputShow',
  props: {
    title: {
      type: String,
      required: false
    },
    getter: {
      type: String,
      required: true
    },
    trans: {
      type: String,
      required: true
    },
    labelClass: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 200
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    value () {
      return parseShow(this.getter, this.trans)
    }
  }
}
</script>

<style lang="scss" scoped>
.col {
  display: flex;
  justify-content: right;
  align-items: center;
}
.detail-text-label {
  display: inline-block;
  width: 100px;
  text-align: right
}
.detail-text-strong {
  margin-left: 10px;
  color: #cc3300;
  font-size: 14px;
  font-weight: bold;
}
.detail-text-strong-blue {
  margin-left: 10px;
  color: #2D8CF0;
  font-size: 14px;
  font-weight: bold;
}
.detail-text-strong-green {
  margin-left: 10px;
  color: #27891A;
  font-size: 14px;
  font-weight: bold;
}
.detail-text-strong-deliver {
  margin-left: 10px;
  color: #ca9606;
  font-size: 13px;
}
.detail-text-grey {
  margin-left: 10px;
  color: #666;
  font-size: 13px;
  font-weight: bold;
}
.detail-text-attention {
  margin-left: 10px;
  color: #cc3300;
  font-size: 13px;
  font-weight: bold;
}
</style>
